import styled from 'styled-components';
import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
import { DEVICE } from '@/constant/unit/device';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
    min-height: 100vh;
    flex-shrink: 0;
    padding: 18px 33px 33px;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
  `,
    HeaderDialogBox: styled.div `
    position: relative;
    display: flex;

    width: 100%;
    height: 122px;
    border-bottom: 1px solid ${SEMANTIC_COLORS.PRIMARY_BORDER};
  `,
    HeaderDialog: styled.div `
    position: relative;
    width: calc(100% - 120px);
    height: fit-content;
    padding: 13px 16px;
    transform: translateX(-10px);

    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    color: ${SEMANTIC_COLORS.SECONDARY_TEXT};

    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
    border: 2px solid ${SEMANTIC_COLORS.PRIMARY_BORDER};
    border-radius: 10px;

    @media ${DEVICE.mobileM} {
      width: calc(100% - 150px);
    }

    & > span {
      word-break: keep-all;
    }

    &::after,
    &::before {
      position: absolute;
      left: calc(100% - 10px);
      display: block;
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      border-radius: 0;
      transform: rotate(15deg);
    }

    &::before {
      top: calc(100% - 19px);
      border-color: transparent transparent ${PALETTE_COLORS.PRIMARY_500} transparent;
      border-width: 12px;
    }

    &::after {
      top: calc(100% - 17px);
      border-color: transparent transparent ${PALETTE_COLORS.NEUTRAL_300} transparent;
      border-width: 9.5px;
    }
  `,
    HeaderImg: styled.img `
    position: absolute;
    top: 44px;
    right: 10px;
    width: 140px;

    @media ${DEVICE.mobileM} {
      top: 28px;
      width: 169px;
    }
  `,
    HeaderNote: styled.div `
    align-self: flex-end;
    margin: 7px 10px 0 0;
    font-size: 16px;
    font-weight: 500;
    color: ${SEMANTIC_COLORS.COMMENT_TEXT};
  `,
    LayoutOptionList: styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 38px 0 10px;
  `,
    OptionChip: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 13px;
    margin-bottom: 18px;
    font-size: 18px;
    line-height: 26px;

    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    text-align: center;
    cursor: pointer;
    background: ${(props) => props.isError
        ? SEMANTIC_COLORS.ERROR_FIELD_BOX_BACKGROUND
        : SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border: ${(props) => props.isError
        ? `3px solid ${SEMANTIC_COLORS.ERROR_BORDER}`
        : props.isSelected
            ? `3px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}`
            : '3px solid transparent'};
    border-radius: 10px;
  `,
    OptionTextarea: styled.textarea `
    width: 100%;
    padding: 9px 14px;
    margin-top: 9px;

    line-height: 23px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    resize: none;
    background: ${SEMANTIC_COLORS.DEFAULT_TEXTAREA_BACKGROUND};

    border: none;
    border-radius: 16px;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${SEMANTIC_COLORS.PLACEHOLDER_TEXT};
    }
  `,
    ErrorFeedbackText: styled.div `
    margin-top: -18px;
    font-weight: 500;
    line-height: 23px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
    opacity: ${(props) => (props.isShow ? 1 : 0)};
  `,
};
